module.exports = __webpack_public_path__ + "static/media/uerre-white.3142cbfa.svg";